<div class="pg-loader-container grit-loader-container message">
  <div
    class="pg-message-container grit-message-container"
    [style.fontWeight]="styleOverides?.fontWeight"
    [style.fontSize]="styleOverides?.fontSize"
    [style.color]="styleOverides?.fontColor"
    [style.fontFamily]="styleOverides?.fontFamily"
  >
    <ng-content
      select="pg-linear-loader-message, grit-linear-loader-message"
    ></ng-content>
  </div>
</div>

<div
  class="pg-load-bar-wrapper grit-load-bar-wrapper"
  [style.background]="styleOverides?.background"
  [@transitionLoaderVisible]="loaderVisibilityState"
  (@transitionLoaderVisible.done)="handleLoaderAnimationDone($event)"
>
  <div
    [style.background]="styleOverides?.fillColor"
    [class.pg-stop-animation]="!loaderRunning"
    class="pg-bar pg-bar1"
  ></div>
  <div
    [style.background]="styleOverides?.fillColor"
    [class.pg-stop-animation]="!loaderRunning"
    class="pg-bar pg-bar2"
  ></div>
  <div
    *ngIf="mode === 'determinate'"
    class="pg-bar pg-bar pg-bar-determinate-fill"
    [ngStyle]="_primaryTransform()"
    [style.background]="styleOverides?.fillColor"
    #primaryValueBar
  ></div>
</div>
<div
  [@transitionProgressAmount]="_progressIndicatorVisibility"
  class="determinate-loader-progress-indicator"
  *ngIf="mode === 'determinate'"
  [style.fontWeight]="styleOverides?.fontWeight"
  [style.color]="styleOverides?.fontColor"
  [style.fontFamily]="styleOverides?.fontFamily"
>
  {{ value }}%
</div>
